import { useEffect, useState } from "react";
import { CONFIG } from "../config";
// @ts-ignore
import * as bootstrap from 'bootstrap';
import Cookies from 'js-cookie';

/**
 * News modal to display the data which is got from WLD API (NEWS.html)
 * @param props 
 * @returns 
 */
export default function NewsModal(props) {

    const [news, setNews] = useState("");
    const COOKIE_READ_NEWS_NAME = "news_read";

    // Create a new cookie which will expired in 1 yeyar
    function addUNewsCookie(newHash) {
      Cookies.set(COOKIE_READ_NEWS_NAME, newHash, { expires: 365, path: '/' })
    }

    /**
     * Check if the release hash received by the WLD API is the same as the stored hash in cookie
     * @param {*} newsReceived The hash was received by the WLD API
     * @returns 
     */
    function hasReadNews(newsReceived) {
      return Cookies.get(COOKIE_READ_NEWS_NAME) != null && Cookies.get(COOKIE_READ_NEWS_NAME) == newsReceived;
    }

    useEffect(() => {
      const MODAL = new bootstrap.Modal(document.getElementById('news-modal'))

      fetch(CONFIG.apiURI+"/news", 
          { 
              method: 'GET',
              mode: "cors",
              headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Accept: 'application/json; charset=utf-8',
                token: props.accessToken
              },
          })
      .then((response) =>
      {
        if(response.ok) {
          return response.json()
        }
      })
      .then((data) => {
          setNews(data.content);
          if(!hasReadNews(data.hash)) {
            MODAL.show()
            addUNewsCookie(data.hash)
          }
        })
      .catch((error) => {});
    }, []);

    return (<>
        <div className="modal fade" id="news-modal" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable modal-fullscreen-md-down modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">NEWS</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body" dangerouslySetInnerHTML={{__html: news}}></div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

    </>)
}